import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { tennispointappPageMeta, tennispointappSchema } from 'components/common/schema'
import Template from 'components/cases/tennispointapp'

const Tennispointapp: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...tennispointappPageMeta} />
      <JsonLd data={tennispointappSchema} />
      <Template />
    </>
  )
}

export default Tennispointapp
